<template>
	<view class="address">
		<view class="address_head">
			<image src="@/static/icon/ic_tips@2x.png" mode="widthFix"></image>
			<view class="address_head_text">
				<text>修改后会影响物流时效、送货上门等服务，只能修 改一次。
					<text class="hui">若因已发货、运费变更等原因导致修改失 败，请您谅解。</text>
				</text>
			</view>
		</view>
		<view class="address_yuan">
			<view class="label">原地址：</view>
			<view class="info">
				<view class="info_top">
					<text>刘美女</text>
					<text>17839484470</text>
				</view>
				<view class="info_bottom">
					<text>上海 上海市 青浦区 夏阳街道华科路新青浦家园144号楼101</text>
				</view>
			</view>
		</view>
		<view class="address_list">
			<view class="label">
				<text>选择新的收货地址：</text>
				<text>添加新地址</text>
			</view>
			<view class="list">
				<view class="list_item" v-for="(item, index) in 3" :key="index">
					<view class="list_item_left">
						<view class="list_item_left_top">
							<text>刘美女</text>
							<text>17839484470</text>
						</view>
						<view class="list_item_left_bottom">
							<text>上海 上海市 青浦区 夏阳街道华科路新青浦家园144号楼101</text>
						</view>
					</view>
					<!-- <image src="@/static/icon/cart_ic_select@2x.png" mode="widthFix"></image> -->
					<image src="@/static/icon/cart_ic_select_grey@2x.png" mode="widthFix"></image>
				</view>
			</view>
		</view>
		<view class="address_footer">
			<view class="address_footer_btn" @click="open">提交修改</view>
		</view>
		<!-- 报名成功弹框 -->
		<uni-popup ref="success" background-color="#fff">
			<view class="popup">
				<view class="popup_icon">
					<image src="@/static/icon/ic_success@2x.png" mode="widthFix"></image>
				</view>
				<view class="popup_info">
					<text>已成功修改至</text>
				</view>
				<view class="popup_box">
					<view class="popup_box_head">
						<text>刘美女</text>
						<text>17839484470</text>
					</view>
					<view class="popup_box_text">
						上海 上海市 青浦区 夏阳街道华科路新青浦
						家园144号楼101
					</view>
				</view>
				<view class="popup_submit1" @click="close">我知道了</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			close() {
				this.$refs.success.close()
			},
			open() {
				this.$refs.success.open('center')
			}
		}
	}
</script>

<style>
	.uni-popup__wrapper {
		border-radius: 32rpx !important;
	}
</style>

<style lang="scss" scoped>
	.address {
		width: 100%;
		.address_head {
			width: 100%;
			padding: 28rpx 34rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			image {
				width: 48rpx;
				height: 48rpx;
				flex-shrink: 0;
				margin-right: 20rpx;
			}
			.address_head_text {
				flex: 1;
				display: flex;
				align-items: center;
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #D20A0A;
					.hui {
						color: #333333;
					}
				}
			}
		}
		.address_yuan {
			width: 100%;
			padding: 28rpx 34rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			display: flex;
			flex-direction: column;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.info {
				margin-top: 28rpx;
				display: flex;
				flex-direction: column;
				.info_top {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin-right: 12rpx;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
				.info_bottom {
					margin-top: 16rpx;
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
			}
		}
		.address_list {
			width: 100%;
			padding: 28rpx 34rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.label {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 28rpx;
				text {
					&:nth-child(1) {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:nth-child(2) {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
			.list {
				display: flex;
				flex-direction: column;
				.list_item {
					display: flex;
					align-items: center;
					padding-bottom: 30rpx;
					border-bottom: 2rpx solid #F4F5F4;
					margin-top: 28rpx;
					&:last-child {
						border: none !important;
						padding-bottom: 0 !important;
					}
					&:first-child {
						margin-top: 0 !important;
					}
					.list_item_left {
						flex: 1;
						display: flex;
						flex-direction: column;
						.list_item_left_top {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-right: 12rpx;
								}
								&:nth-child(2) {
									font-size: 24rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #999999;
								}
							}
						}
						.list_item_left_bottom {
							margin-top: 16rpx;
							text {
								font-size: 24rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #333333;
							}
						}
					}
					image {
						margin-left: 86rpx;
						width: 32rpx;
						height: 32rpx;
						flex-shrink: 0;
					}
				}
			}
		}
		.address_footer {
			width: 100%;
			position: fixed;
			left: 0;
			bottom: 0;
			padding: 0 56rpx calc(20rpx + env(safe-area-inset-bottom)) 56rpx;
			box-sizing: border-box;
			.address_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		.popup {
			width: 554rpx;
			padding: 42rpx 32rpx;
			border-radius: 32rpx;
			box-sizing: border-box;
			.popup_icon {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 136rpx;
					height: 138rpx;
				}
			}
			.popup_box {
				width: 100%;
				padding: 28rpx 24rpx;
				box-sizing: border-box;
				background: #F5F5F5;
				border-radius: 12rpx;
				display: flex;
				flex-direction: column;
				margin-top: 28rpx;
				.popup_box_head {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
							margin-right: 12rpx;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
				.popup_box_text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin-top: 16rpx;
				}
			}
			.popup_info {
				width: 100%;
				margin-top: 46rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.popup_title {
				width: 100%;
				text-align: center;
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.popup_list {
				width: 100%;
				margin-top: 50rpx;
				.popup_list_item {
					width: 100%;
					height: 96rpx;
					display: flex;
					align-items: center;
					border-bottom: 2rpx solid #F4F5F4;
					.popup_list_item_label {
						flex-shrink: 0;
						display: flex;
						align-items: center;
						margin-right: 20rpx;
						.label {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.required {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #ff0000;
						}
						.info {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
					.input {
						flex: 1;
						height: 100%;
						font-size: 32rpx;
					}
					.popup_list_item_submit {
						flex-shrink: 0;
						width: 172rpx;
						height: 56rpx;
						text-align: center;
						line-height: 56rpx;
						background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
						border-radius: 28rpx;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
						margin-left: 20rpx;
					}
				}
			}
			.popup_submit1 {
				width: 100%;
				margin-top: 48rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 56rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
			}
			.popup_submit {
				width: 100%;
				margin-top: 64rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 56rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
			}
		}
	}
</style>